/* fiveaven 23/10/2026 : alerte de retour en stock (snippets/fv-alerte-stock.liquid).
   La cloche remplace le cœur des favoris (rond posé par snippets/fv-favoris dans .fv-pdp-rangee) quand la déclinaison choisie
   est épuisée ; elle ouvre le champ e-mail sous la ligne. Sans rangée de favoris, la cloche se place en tête du bloc.
   Inscription par l'API publique Back in Stock de Klaviyo (clé publique du compte, non secrète) ; Klaviyo envoie l'e-mail
   par son flux « Back in Stock » quand la déclinaison revient. Déclinaison Shopify : $shopify:::$default:::<id>.
   Une inscription réussie est retenue dans ce navigateur (localStorage) pour afficher « C'est noté » au retour sur la fiche. */
(function () {
  var CLE = "T48wRv", REVISION = "2025-01-15";
  var URL_API = "https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=" + CLE;
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function lu(v) { try { return localStorage.getItem("fvas:" + v); } catch (e) { return null; } }
  function noter(v, email) { try { localStorage.setItem("fvas:" + v, email); } catch (e) {} }

  function init(el) {
    if (el.dataset.pret) return; el.dataset.pret = "1";
    var form = el.querySelector("[data-fvas-form]"), ok = el.querySelector(".fvas__ok"), modele = el.querySelector("template[data-fvas-cloche]");
    var champ = form.querySelector("input[type=email]"), valider = form.querySelector("button[type=submit]"), message = form.querySelector(".fvas__message");
    var variante = el.dataset.variante, epuise = !el.hidden, rangee = null;
    var cloche = modele.content.firstElementChild.cloneNode(true);

    function placer() { // à côté du bouton « Épuisé », à la place du cœur ; sinon en tête du bloc
      rangee = document.querySelector(".fv-pdp-rangee");
      if (rangee) rangee.appendChild(cloche);
      else { el.insertBefore(cloche, el.firstChild); el.classList.add("fvas--seul"); }
      maj();
    }
    function maj() {
      var fait = !!lu(variante);
      el.hidden = !epuise;
      if (rangee) rangee.classList.toggle("fvas-epuise", epuise);
      else cloche.hidden = !epuise;
      cloche.classList.toggle("is-on", fait);
      cloche.setAttribute("aria-label", fait ? "Alerte de retour activée" : "M’alerter du retour");
      ok.hidden = !fait || form.hidden === false;
    }
    function ouvrir(o) {
      if (lu(variante)) { ok.hidden = !ok.hidden; return; } // déjà inscrit : la cloche montre la confirmation
      form.hidden = !o; cloche.setAttribute("aria-expanded", o ? "true" : "false");
      if (o) setTimeout(function () { champ.focus({ preventScroll: true }); }, 50);
    }

    cloche.addEventListener("click", function () { ouvrir(form.hidden); });
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var email = champ.value.trim();
      if (!EMAIL.test(email)) { champ.setAttribute("aria-invalid", "true"); message.textContent = "Vérifie ton adresse e-mail."; champ.focus(); return; }
      champ.removeAttribute("aria-invalid"); message.textContent = ""; valider.disabled = true;
      var corps = { data: { type: "back-in-stock-subscription", attributes: { channels: ["EMAIL"], profile: { data: { type: "profile", attributes: { email: email } } } },
        relationships: { variant: { data: { type: "catalog-variant", id: "$shopify:::$default:::" + variante } } } } };
      fetch(URL_API, { method: "POST", headers: { "Content-Type": "application/vnd.api+json", revision: REVISION }, body: JSON.stringify(corps) })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          noter(variante, email);
          form.hidden = true; cloche.setAttribute("aria-expanded", "false"); maj(); ok.hidden = false;
          ok.setAttribute("tabindex", "-1"); ok.focus();
        })
        .catch(function () { message.textContent = "L’inscription n’a pas abouti. Réessaie dans un instant."; })
        .finally(function () { valider.disabled = false; });
    });

    // changement de déclinaison sur la fiche : la cloche et le cœur suivent la déclinaison choisie
    document.addEventListener("eurus:variant:change", function (e) {
      var v = e.detail && e.detail.variant; if (!v || !v.id) return;
      variante = String(v.id); epuise = !v.available; message.textContent = "";
      form.hidden = true; cloche.setAttribute("aria-expanded", "false"); ok.hidden = true; maj();
    });

    // la rangée « Épuisé + cœur » est posée par le script des favoris : on l'attend un court instant
    var essais = 0;
    (function attendre() {
      if (document.querySelector(".fv-pdp-rangee") || essais++ > 30) { placer(); suite(); return; }
      setTimeout(attendre, 100);
    })();
    function suite() { // arrivée depuis une carte produit épuisée (lien …#alerte) : formulaire ouvert, champ prêt
      if (location.hash === "#alerte" && epuise && !lu(variante)) {
        ouvrir(true);
        setTimeout(function () { (rangee || el).scrollIntoView({ block: "center" }); }, 300);
      }
    }
  }

  function tout() { document.querySelectorAll("[data-fvas]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", tout); else tout();
  document.addEventListener("shopify:section:load", tout);
})();
